import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Fade } from "@mui/material";
import Button from "@mui/material/Button";
import Cropper from "react-cropper";
import axios from "axios";
import "cropperjs/dist/cropper.css";
import "./styles/Sidebar.css";
import Eng from "/assets/Eng.png";
import Th from "/assets/TH.png";
import Logo from "/assets/logo - sidebar.png";
import arrowL from "/assets/ArrowL.svg";
import arrowR from "/assets/ArrowR.svg";
import ProfileIcon from "/assets/avatar_face_man_boy_profile_smiley_happy_people_icon_181659.png";
import dashboard from "/assets/Property 1=Dashboard.png";
import Lightbulb from "/assets/Property 1=Lightbulb.png";
import Report from "/assets/Property 1=report.png";
import Brach from "/assets/Property 1=Brach.png";
import People from "/assets/Property 1=People alt.png";

const SidebarAdmin = () => {
  const { t, i18n } = useTranslation();
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [isEngIcon, setIsEngIcon] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [tempName, setTempName] = useState("");
  const [profileImage, setProfileImage] = useState(ProfileIcon);
  const [tempImage, setTempImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [selectedLink, setSelectedLink] = useState("");
  const [permissions, setPermissions] = useState(null);
  const location = useLocation();
  const cropperRef = useRef(null);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [originalProfileImage, setOriginalProfileImage] = useState(ProfileIcon);
  const [loadingLogout, setLoadingLogout] = useState(false);
  const [logoutLoadingText, setLogoutLoadingText] = useState("กำลังออกจากระบบ");
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const updateUnreadCount = () => {
      const storedData =
        JSON.parse(sessionStorage.getItem("auditRecords")) || [];
      const storedViewedStates =
        JSON.parse(sessionStorage.getItem("viewedStates")) || {};
      const unreadRecords = storedData.filter(
        (record, index) => !storedViewedStates[index]
      );
      setUnreadCount(unreadRecords.length);
    };

    updateUnreadCount();
    const intervalId = setInterval(updateUnreadCount, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    i18n.changeLanguage("th");
  }, [i18n]);

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    if (userData) {
      setUserName(userData.name || "");
      setTempName(userData.name || "");
    }
  }, []);

  useEffect(() => {
    const fetchAvatar = async () => {
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      if (userData && userData.id) {
        try {
          const response = await axios.get(
            `${import.meta.env.VITE_API_URL}/user/${userData.id}/avatar`,
            { responseType: "blob" }
          );
          const imageUrl = URL.createObjectURL(response.data);
          setProfileImage(imageUrl);
          setOriginalProfileImage(imageUrl);
        } catch (error) {
          console.error("Error fetching avatar:", error);
        }
      }
    };

    fetchAvatar();
  }, []);

  useEffect(() => {
    const fetchPermissions = async () => {
      const storedUserData = JSON.parse(sessionStorage.getItem("userData"));
      const userId = storedUserData?.id;
      const selectedBranch = sessionStorage.getItem("selectedBranch");
  
      // ถ้าไม่มี userId หรือ selectedBranch ให้ return ออกจากฟังก์ชันโดยไม่ทำอะไร
      if (!userId || !selectedBranch) {
        return;
      }
  
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/permissions/${userId}/${selectedBranch}`
        );
        setPermissions(response.data);
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };
  
    fetchPermissions();
  }, []);
  
  const handleLinkClick = (path) => {
    if (window.innerWidth <= 768) setIsMenuExpanded(false);
    setSelectedLink(path);

    if (path === "/alert") {
      const storedData =
        JSON.parse(sessionStorage.getItem("auditRecords")) || [];
      const viewedStates = storedData.reduce((acc, _, index) => {
        acc[index] = true;
        return acc;
      }, {});
      sessionStorage.setItem("viewedStates", JSON.stringify(viewedStates));
      setUnreadCount(0);
    }
  };

  const handleLanguageSelect = (language) => {
    setIsLanguageMenuOpen(false);
    if (language === "en") {
      i18n.changeLanguage("en");
      setIsEngIcon(true);
    } else if (language === "th") {
      i18n.changeLanguage("th");
      setIsEngIcon(false);
    }
  };

  const handleUploadImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert(t("File size exceeds 5MB. Please choose a smaller image."));
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setTempImage(reader.result);
        setIsCropModalOpen(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCancelCrop = () => {
    setTempImage(null);
    setIsCropModalOpen(false);
  };

  const handleSaveCroppedImage = () => {
    const cropper = cropperRef.current?.cropper;
    cropper.getCroppedCanvas().toBlob((blob) => {
      const fileUrl = URL.createObjectURL(blob);
      setCroppedImage(fileUrl);
      setIsCropModalOpen(false);
    }, "image/jpeg");
  };

  const handleSaveProfile = async () => {
    try {
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      const userId = userData.id;

      if (tempName !== userName) {
        await axios.put(`${import.meta.env.VITE_API_URL}/user/${userId}`, {
          name: tempName,
        });
        setUserName(tempName);

        // อัพเดต sessionStorage
        const updatedUserData = { ...userData, name: tempName };
        sessionStorage.setItem("userData", JSON.stringify(updatedUserData));
      }

      if (croppedImage) {
        const formData = new FormData();
        const blob = await fetch(croppedImage).then((r) => r.blob());
        formData.append("avatar", blob, "avatar.jpg");

        const response = await axios.put(
          `${import.meta.env.VITE_API_URL}/user/${userId}/avatar`,
          formData
        );

        if (response.status === 200) {
          const updatedUserData = {
            ...userData,
            avatar: response.data.user.avatar,
          };
          sessionStorage.setItem("userData", JSON.stringify(updatedUserData));
          setProfileImage(croppedImage);
          setOriginalProfileImage(croppedImage);
        }
      }

      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Error updating profile:", error);
      alert(t("Failed to update profile. Please try again."));
    }
  };

  const handleBergerClick = () => {
    const sidebar = document.querySelector(".sidebar");
    sidebar.classList.toggle("sidebar-collapsed");
    setIsMenuExpanded(!isMenuExpanded);

    const notificationBadges = document.querySelectorAll(".notification-badge");
    notificationBadges.forEach((badge) => {
      badge.classList.toggle("notification-badge-collapsed");
    });
  };

  const handleLogoutClick = () => setShowLogoutModal(true);
  const handleCancelLogout = () => setShowLogoutModal(false);

  const handleConfirmLogout = () => {
    setLoadingLogout(true);
    sessionStorage.clear();

    let timeLeft = 3;
    setLogoutLoadingText("กำลังออกจากระบบ");
    const countdownInterval = setInterval(() => {
      timeLeft -= 0.5;
      setLogoutLoadingText((prev) =>
        prev.length < 21 ? prev + "." : "กำลังออกจากระบบ"
      );
      if (timeLeft <= 0) {
        clearInterval(countdownInterval);
        if (!sessionStorage.getItem("userData")) {
          navigate("/login", { replace: true });
        }
      }
    }, 300);
  };

  const handleCancelEdit = () => {
    setTempName(userName);
    setTempImage(null);
    setCroppedImage(null);
    setIsEditModalOpen(false);
  };

  return (
    <>
      <div className="navbar">
        <div className="hamburger-icon" onClick={handleBergerClick}>
          &#8801;
        </div>
        <div
          className="language"
          onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}
        >
          <img
            src={isEngIcon ? Eng : Th}
            className="img-size"
            alt="Language Icon"
          />
        </div>

        {isLanguageMenuOpen && (
          <div className="language-menu">
            <li onClick={() => handleLanguageSelect("en")}>
              <img src={Eng} alt="Eng" className="img-sizemenu" /> English
            </li>
            <li onClick={() => handleLanguageSelect("th")}>
              <img src={Th} alt="TH" className="img-sizemenu" /> ไทย
            </li>
          </div>
        )}

        <ul>
          <li className="logout">
            <Button
              variant="text"
              onClick={handleLogoutClick}
              sx={{
                fontFamily: '"IBM Plex Sans Thai", sans-serif',
                textTransform: "none",
                color: "white",
                height: "30px",
              }}
            >
              {t("Logout")}
            </Button>
          </li>
        </ul>
      </div>

      <div className="sidebar">
        <div className="sidebar_section">
          <div className="logo-sidebar">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="profile-section">
            <li>
              <div className="profile-info">
                <img
                  src={profileImage || ProfileIcon}
                  alt="Profile"
                  className="profile-picture"
                  onError={(e) => {
                    console.error("Error loading image:", e);
                    e.target.src = ProfileIcon;
                  }}
                />
              </div>
            </li>
            <div className="profile-name">
              <a>{userName}</a>
            </div>
            <div
              className="profile-edit"
              onClick={() => {
                setTempName(userName);
                setIsEditModalOpen(true);
              }}
            >
              <a>{t("Edit Profile")}</a>
            </div>
          </div>
          <div className="berger" onClick={handleBergerClick}>
            <img src={isMenuExpanded ? arrowR : arrowL} alt="arrow" />
          </div>

          <ul>
            <li>
              <Link
                to="/main"
                className={location.pathname === "/main" ? "active-link" : ""}
                onClick={() => handleLinkClick("/main")}
              >
                <div className="sidebar-icon">
                  <img src={dashboard} alt="dashboard" />
                </div>
                <span>{t("Dashboard")}</span>
              </Link>
            </li>

            <div className="sidebar-heading-admin">การจัดการ</div>

            <li>
              <Link
                to="/branchmanagement"
                className={
                  location.pathname === "/branchmanagement" ||
                  location.pathname === "/branchdetails"
                    ? "active-link"
                    : ""
                }
                onClick={() => handleLinkClick("/branchmanagement")}
              >
                <div className="sidebar-icon">
                  <img src={Brach} alt="Branch" />
                </div>
                <span>สาขา</span>
              </Link>
            </li>
            <li>
              <Link
                to="/usermanagement"
                className={
                  location.pathname === "/usermanagement" ? "active-link" : ""
                }
                onClick={() => handleLinkClick("/usermanagement")}
              >
                <div className="sidebar-icon">
                  <img src={People} alt="People" />
                </div>
                <span>ผู้ใช้งาน</span>
              </Link>
            </li>
            <li>
              <Link
                to="/lightswitch"
                className={
                  location.pathname === "/lightswitch" ||
                  location.pathname === "/poledetails"
                    ? "active-link"
                    : ""
                }
                onClick={() => handleLinkClick("/lightswitch")}
              >
                <div className="sidebar-icon">
                  <img src={Lightbulb} alt="Lightbulb" />
                </div>
                <span>เสาไฟ</span>
              </Link>
            </li>
            <li>
              <Link
                to="/reportadmin"
                className={
                  location.pathname === "/reportadmin" ||
                  location.pathname.startsWith("/report/")
                    ? "active-link"
                    : ""
                }
                onClick={() => handleLinkClick("/reportadmin")}
              >
                <div className="sidebar-icon">
                  <img src={Report} alt="Report" />
                </div>
                <span>{t("Reports")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {showLogoutModal && (
        <div className="logout-modal">
          <Fade in={showLogoutModal}>
            <div className="logout-modal-content">
              {loadingLogout ? (
                <p className="logoutText">{logoutLoadingText}</p>
              ) : (
                <>
                  <p>ต้องการออกจากระบบ ?</p>
                  <div className="logout-modal-buttons">
                    <Button
                      variant="text"
                      onClick={handleCancelLogout}
                      sx={{
                        fontFamily: '"IBM Plex Sans Thai", sans-serif',
                        color: "#2762F8",
                        width: "100px",
                        height: "40px",
                        backgroundColor: "#ffffff",
                        boxShadow: "none",
                        ":hover": {
                          backgroundColor: "#e0e0e0",
                          boxShadow: "none",
                          color: "#2762F8",
                        },
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleConfirmLogout}
                      sx={{
                        fontFamily: '"IBM Plex Sans Thai", sans-serif',
                        width: "150px",
                        height: "40px",
                        boxShadow: "none",
                        backgroundColor: "#2762F8",
                        color: "#ffffff",
                        ":hover": {
                          backgroundColor: "#1e50d2",
                          boxShadow: "none",
                        },
                      }}
                    >
                      ออกจากระบบ
                    </Button>
                  </div>
                </>
              )}
            </div>
          </Fade>
        </div>
      )}

      {isEditModalOpen && (
        <div className="modal-background-fixed">
          <Fade in={isEditModalOpen}>
            <div className="edit-modal">
              <h2 className="edit-modal-title">{t("Edit Profile")}</h2>
              <div className="edit-section">
                <input
                  id="nameInput"
                  type="text"
                  value={tempName}
                  onChange={(e) => setTempName(e.target.value)}
                  className="name-input"
                />
              </div>
              <div className="edit-section">
                <div className="profile-picture-container">
                  <img
                    src={croppedImage || profileImage || ProfileIcon}
                    alt="Profile"
                    className="profile-picture-edit"
                  />
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleUploadImage}
                  id="imageInput"
                  style={{ display: "none" }}
                />
                <label htmlFor="imageInput" className="upload-button">
                  {t("Choose Image")}
                </label>
              </div>
              <div className="modal-buttons">
                <Button
                  variant="outlined"
                  onClick={handleCancelEdit}
                  sx={{
                    fontFamily: '"IBM Plex Sans Thai", sans-serif',
                    color: "#2762F8",
                    width: "120px",
                    height: "50px",
                    borderColor: "#2762F8",
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      borderColor: "#2762F8",
                      backgroundColor: "#f0f5ff",
                      fontWeight: "bold",
                    },
                  }}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSaveProfile}
                  sx={{
                    fontFamily: '"IBM Plex Sans Thai", sans-serif',
                    width: "120px",
                    height: "50px",
                    boxShadow: "none",
                    backgroundColor: "#0077ff",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#1e50d2",
                      boxShadow: "none",
                      fontWeight: "bold",
                    },
                  }}
                >
                  {t("Save")}
                </Button>
              </div>
            </div>
          </Fade>
        </div>
      )}

      {isCropModalOpen && (
        <div className="modal-background-fixed">
          <Fade in={isCropModalOpen}>
            <div className="crop-modal">
              <h2 className="crop-modal-title">{t("Crop Your Image")}</h2>
              <div className="cropper-wrapper">
                {tempImage && (
                  <Cropper
                    src={tempImage}
                    initialAspectRatio={1}
                    aspectRatio={1}
                    guides={true}
                    ref={cropperRef}
                    viewMode={1}
                    minCropBoxHeight={100}
                    minCropBoxWidth={100}
                    background={false}
                    responsive={true}
                    autoCropArea={1}
                    checkOrientation={false}
                    style={{ height: 400, width: "100%" }}
                  />
                )}
              </div>
              <div className="crop-instructions">
                {t("Drag the corners to adjust the crop area")}
              </div>
              <div className="modal-buttons">
                <Button
                  variant="outlined"
                  onClick={handleCancelCrop}
                  sx={{
                    fontFamily: '"IBM Plex Sans Thai", sans-serif',
                    color: "#2762F8",
                    width: "140px",
                    height: "40px",
                    borderColor: "#2762F8",
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      borderColor: "#2762F8",
                      backgroundColor: "#f0f5ff",
                    },
                  }}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSaveCroppedImage}
                  sx={{
                    fontFamily: '"IBM Plex Sans Thai", sans-serif',
                    width: "140px",
                    height: "40px",
                    boxShadow: "none",
                    backgroundColor: "#2762F8",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#1e50d2",
                      boxShadow: "none",
                    },
                  }}
                >
                  {t("Apply")}
                </Button>
              </div>
            </div>
          </Fade>
        </div>
      )}
    </>
  );
};

export default SidebarAdmin;
